import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'customer-contacts';

const createCustomerContact = async (body) => {
  const method = 'POST';
  const url = `${USE_CASE_URL}`;

  const json = await request({ method, url, body });
  return json;
};

export default createCustomerContact;
